import React from 'react';
import { Outlet } from 'react-router-dom';
import { Sidebar, MobileTabBar, CommandPalette } from '../shell';

export const MainLayout: React.FC = () => (
  <div className="flex min-h-screen bg-paper text-ink">
    <Sidebar />
    <main className="min-w-0 flex-1 pb-14 md:pb-0">
      <Outlet />
    </main>
    <MobileTabBar />
    <CommandPalette />
  </div>
);
